// frontend/src/index.tsx (or main.tsx)
import React from 'react';
import ReactDOM from 'react-dom/client'; // or 'react-dom'
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider> {/* Wrap your App with AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);